
import { Link } from 'react-router-dom';

export default function OnlineMedicationGuidance() {
  const services = [
    {
      name: 'クロンお薬サポート (curon)',
      description: '多くの医療機関で導入実績のあるオンライン診療サービス「クロン」と連携した服薬指導サービスです。患者さんはアプリ不要で利用できる手軽さも特徴です。診療から服薬指導、決済、薬の配送までを一貫して行うことができます。',
      features: ['アプリ不要で利用可能', '診療から配送まで一貫対応', '多くの医療機関で導入実績'],
      icon: 'ri-smartphone-line',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      name: 'ソクヤク (SOKUYAKU)',
      description: 'ジェイフロンティア株式会社が提供するサービスで、特定のエリア内であれば最短当日中にお薬が届く配送サービスが特徴です。アプリにはかりつけの医療機関や薬局を登録する機能やお薬手帳機能も備わっています。',
      features: ['最短当日配送', 'かりつけ医療機関登録', 'お薬手帳機能'],
      icon: 'ri-truck-line',
      color: 'bg-green-50 text-green-600'
    },
    {
      name: 'Pharms (ファームス)',
      description: '株式会社メドレーが提供しており、同社のオンライン診療アプリ「CLINICS（クリニクス）」と連携しています。処方箋のネット受付やお薬手帳アプリとの連携、服薬期間中のフォローアップ機能などが充実しており、薬局業務全体の効率化をサポートします。',
      features: ['CLINICS連携', '処方箋ネット受付', 'フォローアップ機能充実'],
      icon: 'ri-hospital-line',
      color: 'bg-purple-50 text-purple-600'
    },
    {
      name: 'NiCOMS (ニコムス)',
      description: '日本調剤が自社で開発・提供しているサービスで、日本調剤の全店舗で利用可能です。事前に予約することで待ち時間なく服薬指導を受けられ、お薬は自宅などに配送されます。',
      features: ['日本調剤全店舗対応', '事前予約で待ち時間なし', '自宅配送対応'],
      icon: 'ri-store-line',
      color: 'bg-orange-50 text-orange-600'
    },
    {
      name: 'kakari (カカリ)',
      description: 'かりつけ薬局としての利用に特化したアプリです。薬局検索機能をあえて搭載せず、患者さんがいつも利用する薬局とつながることを重視しています。チャット機能や服薬フォロー機能も充実しています。',
      features: ['かりつけ薬局特化', 'チャット機能', '服薬フォロー充実'],
      icon: 'ri-chat-3-line',
      color: 'bg-teal-50 text-teal-600'
    },
    {
      name: 'CARADA オンライン診療',
      description: '直感的でシンプルな操作性が特徴のシステムです。予約からビデオ通話での服薬指導、クレジットカード決済、薬の配送まで対応しています。',
      features: ['シンプルな操作性', 'ビデオ通話対応', 'クレジット決済'],
      icon: 'ri-video-chat-line',
      color: 'bg-red-50 text-red-600'
    }
  ];

  const benefits = [
    {
      title: '時間の節約',
      description: '薬局への移動時間や待ち時間を削減できます',
      icon: 'ri-time-line'
    },
    {
      title: '感染リスク軽減',
      description: '外出を控えたい方も安心して服薬指導を受けられます',
      icon: 'ri-shield-check-line'
    },
    {
      title: '継続的なサポート',
      description: '定期的なフォローアップで服薬管理をサポート',
      icon: 'ri-heart-pulse-line'
    },
    {
      title: '薬の配送',
      description: 'ご自宅や指定場所への薬の配送サービス',
      icon: 'ri-home-heart-line'
    }
  ];

  const steps = [
    {
      step: '1',
      title: '医療機関での診療',
      description: 'オンライン診療または対面診療で処方箋を受け取ります'
    },
    {
      step: '2',
      title: 'サービスの予約',
      description: '利用したいオンライン服薬指導サービスで予約を取ります'
    },
    {
      step: '3',
      title: 'ビデオ通話での指導',
      description: '薬剤師とビデオ通話で服薬指導を受けます'
    },
    {
      step: '4',
      title: '薬の受け取り',
      description: '薬局での受け取りまたは配送で薬を受け取ります'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <div className="flex items-center space-x-6">
              <nav className="hidden md:flex space-x-8">
                <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
                <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
                <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
                <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
              </nav>
            </div>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-indigo-50 py-20">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/73e8e919c54c60b68f8cf9feffc8450f.jpg"
            alt="オンライン服薬指導の様子"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              <span className="text-blue-600">オンライン服薬指導</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
              スマートフォンやパソコンのビデオ通話機能を使って、薬剤師からお薬の説明を受けることができる仕組みです。薬局へ行く時間がない方や、感染症のリスクを避けたい方にとって便利なサービスとして利用が広がっています。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-blue-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                サービスを探す
              </button>
              <button className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer">
                利用方法を見る
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">オンライン服薬指導のメリット</h2>
            <p className="text-lg text-gray-600">従来の薬局での服薬指導と同等の質を保ちながら、より便利にご利用いただけます</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">利用の流れ</h2>
            <p className="text-lg text-gray-600">簡単4ステップでオンライン服薬指導をご利用いただけます</p>
          </div>
          
          <div className="grid md:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-xl font-bold">
                  {step.step}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-6 left-full w-full">
                    <i className="ri-arrow-right-line text-gray-400 text-xl"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">主なオンライン服薬指導サービス</h2>
            <p className="text-lg text-gray-600">現在利用できる主要なサービスをご紹介します</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-smartphone-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">①クロンお薬サポート (curon)</h3>
              </div>
              <p className="text-gray-600 mb-4">
                多くの医療機関で導入実績のあるオンライン診療サービス「クロン」と連携した服薬指導サービスです。患者さんはアプリ不要で利用できる手軽さも特徴です。診療から服薬指導、決済、薬の配送までを一貫して行うことができます。
              </p>
              <a 
                href="https://app.curon.co/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
              >
                サービス詳細を見る
                <i className="ri-external-link-line ml-1"></i>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-truck-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">②ソクヤク (SOKUYAKU)</h3>
              </div>
              <p className="text-gray-600 mb-4">
                ジェイフロンティア株式会社が提供するサービスで、特定のエリア内であれば最短当日中にお薬が届く配送サービスが特徴です。アプリにはかりつけの医療機関や薬局を登録する機能やお薬手帳機能も備わっています。
              </p>
              <a 
                href="https://sokuyaku.jp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
              >
                サービス詳細を見る
                <i className="ri-external-link-line ml-1"></i>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-hospital-line text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">③Pharms (ファームス)</h3>
              </div>
              <p className="text-gray-600 mb-4">
                株式会社メドレーが提供しており、同社のオンライン診療アプリ「CLINICS（クリニクス）」と連携しています。処方箋のネット受付やお薬手帳アプリとの連携、服薬期間中のフォローアップ機能などが充実しており、薬局業務全体の効率化をサポートします。
              </p>
              <a 
                href="https://pharms-cloud.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
              >
                サービス詳細を見る
                <i className="ri-external-link-line ml-1"></i>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-heart-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">④kakari (カカリ)</h3>
              </div>
              <p className="text-gray-600 mb-4">
                かりつけ薬局としての利用に特化したアプリです。薬局検索機能をあえて搭載せず、患者さんがいつも利用する薬局とつながることを重視しています。チャット機能や服薬フォロー機能も充実しています。
              </p>
              <a 
                href="https://kakari.medpeer.jp/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
              >
                サービス詳細を見る
                <i className="ri-external-link-line ml-1"></i>
              </a>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 md:col-span-2">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-computer-line text-2xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">⑤CARADA オンライン診療</h3>
              </div>
              <p className="text-gray-600 mb-4">
                直感的でシンプルな操作性が特徴のシステムです。予約からビデオ通話での服薬指導、クレジットカード決済、薬の配送まで対応しています。
              </p>
              <a 
                href="https://lp.telemedicine.carada.jp/p" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium"
              >
                サービス詳細を見る
                <i className="ri-external-link-line ml-1"></i>
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* Selection Guide Section */}
      <section className="py-16 bg-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">サービスの選び方のポイント</h2>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  <i className="ri-hospital-line text-blue-600 mr-2"></i>
                  医療機関・薬局の対応状況を確認
                </h3>
                <p className="text-gray-600 mb-4">
                  どのサービスを利用できるかは、かりつけの医療機関や薬局によって決まります。まずは、利用したい病院や薬局に、オンライン服薬指導に対応しているか、またどのサービスを使っているかを確認するのが一番確実です。
                </p>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <h4 className="font-medium text-blue-900 mb-2">確認すべきポイント</h4>
                  <ul className="space-y-1 text-sm text-blue-800">
                    <li>• オンライン服薬指導の対応可否</li>
                    <li>• 使用しているシステム・アプリ</li>
                    <li>• 配送エリアと配送料</li>
                    <li>• 予約方法と利用時間</li>
                  </ul>
                </div>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  <i className="ri-smartphone-line text-blue-600 mr-2"></i>
                  利用環境と機能を比較
                </h3>
                <p className="text-gray-600 mb-4">
                  各サービスによって、アプリのダウンロードが必要かどうか、操作の簡単さ、追加機能などが異なります。ご自身の利用環境に合ったサービスを選択しましょう。
                </p>
                <div className="bg-green-50 p-4 rounded-lg">
                  <h4 className="font-medium text-green-900 mb-2">比較ポイント</h4>
                  <ul className="space-y-1 text-sm text-green-800">
                    <li>• アプリダウンロードの要否</li>
                    <li>• 操作の簡単さ</li>
                    <li>• お薬手帳機能の有無</li>
                    <li>• フォローアップ機能</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Services Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">その他のサービス</h2>
          </div>
          
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-apps-line text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">各社独自のアプリ</h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                上記以外にも、各企業が独自に開発したアプリによってオンライン服薬指導に対応している場合があります。かりつけの薬局にお問い合わせいただくか、薬局のウェブサイトでご確認ください。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-indigo-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">オンライン服薬指導を始めてみませんか？</h2>
          <p className="text-xl text-blue-100 mb-8">
            まずはかりつけの医療機関・薬局にお問い合わせください
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/family-pharmacist"
              className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              かりつけ薬剤師を探す
            </Link>
            <Link 
              to="/health-support"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              健康サポートを見る
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-consultation" className="hover:text-white cursor-pointer">健康相談</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
                <li><Link to="/online-medication-guidance" className="hover:text-white cursor-pointer">オンライン服薬指導</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/dx" className="hover:text白 cursor-pointer">薬局DX</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職・派遣情報</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/official-links" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">転職・派遣情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
